module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-classic-2-8ca651cbfc52319516ed6da1d960d413.webp";